export const baseUrl = window.location.hostname === "localhost" ? 'http://localhost:3000/' : (window.apiUrl || '/');
